import { useSelector } from 'react-redux';
import useUser from '../queries/user';
import config from '../config/config';

// staff mode is a feature that allows staff members to see the app with all features turned on
// but also as a "normal" user. This is useful for testing and debugging purposes.
// the feature is visible only to Gloat staff members.
export const useIsStaffModeOn = (): boolean => {
  const { data: user } = useUser();

  const isUserStaffScope = useSelector<{ auth: { scope: { isStaffModeOn: boolean } } }>(
    state => state?.auth?.scope?.isStaffModeOn,
  );
  const isUserIsStaff = user?.isStaff || config?.isStaffModeAllowed;

  return !!(isUserStaffScope && isUserIsStaff);
};
